<div class="cm-button-list">
    <cm-button (click)="copyConfiguratorUrl(false)">
        <ng-container cm-text> Copy configurator URL </ng-container>
    </cm-button>
    <cm-button (click)="copyConfiguratorUrl(true)">
        <ng-container cm-text> Copy configurator URL with parameters </ng-container>
    </cm-button>
    <cm-button (click)="downloadStl()">
        <ng-container cm-text> Download STL data for current variant </ng-container>
    </cm-button>
    <cm-three-template-scene-provider (onInitialized)="setThreeSceneManagerService($event)">
        <cm-button (click)="downloadGltf()" [style]="{width: '100%'}">
            <ng-container cm-text> Download GLTF data for current variant </ng-container>
        </cm-button>
    </cm-three-template-scene-provider>
    <cm-button (click)="clearArForCurrentVariant()">
        <ng-container cm-text> Clear AR for current variant </ng-container>
    </cm-button>
    <cm-button (click)="clearArForAllVariants()">
        <ng-container cm-text> Clear AR for all variants </ng-container>
    </cm-button>
    <cm-button (click)="createArForCurrentVariant()">
        <ng-container cm-text> Create AR for current variant </ng-container>
    </cm-button>
    <cm-button (click)="createArForAllVariants()">
        <ng-container cm-text> Create AR for all variants </ng-container>
    </cm-button>
</div>
